import { MenuItem } from "@mui/material";
import { memo, useEffect, useMemo } from "react";
import MuiSelect from "../../shared/MuiSelect";
import { useQuery } from "react-query";
import { getCategories } from "../../Services/SpecificationTypes";

const FormSelect = ({ category, setCategory, categoryId, categoryName }) => {
  const { data: categoryData } = useQuery(["categories"], getCategories);

  const categoryList = useMemo(() => categoryData?.data?.data, [categoryData]);
  useEffect(() => {
    if (categoryId) {
      setCategory(categoryId);
    } else if (categoryName) {
      setCategory(
        categoryList.find((item) => item.category === categoryName).id
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MuiSelect
      name="category_id"
      id="category_id"
      className="!w-full"
      label="Category"
      placeholder="Select Category"
      value={category}
      onChange={(event) => setCategory(event.target.value)}
    >
      {categoryList?.map((category) => {
        return (
          <MenuItem key={category.id} value={category.id}>
            {category.category}
          </MenuItem>
        );
      })}
    </MuiSelect>
  );
};

export default memo(FormSelect);
